import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { InsightsState } from 'app-redux/InsightsState';
import { nameof } from 'utils/typeHelpers';

import * as dto from 'client/dto';

export type UserState = {
  userProfile: dto.UserModel;
  roles: dto.UserTypeModel[];
  groups: dto.UserGroupModel[];
  isLoadingSettings: boolean;
  isSubmittingSettings: boolean;
};

export const InitialUserState: UserState = {
  userProfile: null,
  roles: [],
  groups: [],
  isLoadingSettings: false,
  isSubmittingSettings: false,
};

const userSlice = createSlice({
  name: nameof<InsightsState>('user'),
  initialState: InitialUserState,
  reducers: {
    startLoadingSettings: state => {
      state.isLoadingSettings = true;
    },
    startSubmittingSettings: state => {
      state.isLoadingSettings = true;
      state.isSubmittingSettings = true;
    },
    finishLoadingSettings: state => {
      state.isLoadingSettings = false;
    },
    finishSubmittingSettings: state => {
      state.isLoadingSettings = false;
      state.isSubmittingSettings = false;
    },
    setUserProfile: (state, action: PayloadAction<dto.UserModel>) => {
      state.userProfile = action.payload;
    },
    setRoles: (state, action: PayloadAction<dto.UserTypeModel[]>) => {
      state.roles = action.payload ?? [];
    },
    setGroups: (state, action: PayloadAction<dto.UserGroupModel[]>) => {
      state.groups = action.payload ?? [];
    },
  },
});

const { actions, reducer } = userSlice;

export const {
  startLoadingSettings,
  startSubmittingSettings,
  finishLoadingSettings,
  finishSubmittingSettings,
  setUserProfile,
  setRoles,
  setGroups,
} = actions;

export default reducer;
